export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9432.b6f47bbe.jpg";